"use client"

import { memo, useEffect, useState } from "react"
import { resolveImageUrl } from "@/lib/mediaUrl"

export const FALLBACK_IMAGE = "/no-image.png"

/**
 * Public news images — plain <img> so SSR and no-JS get a real src in HTML.
 * Missing src or load error → /no-image.png (error swap needs JS).
 */
const CustomImage = ({
    src,
    alt = "Prajavarta News",
    width = 600,
    height = 400,
    className = "",
    style = {},
    priority = false,
    folder = "news",
    crop = "fill",
    gravity = "auto",
    objectFit = "cover",
}) => {
    const resolvedSrc = resolveImageUrl(src, folder, {
        width: typeof width === "number" ? width : undefined,
        height: typeof height === "number" ? height : undefined,
        crop,
        gravity,
    })

    const [displaySrc, setDisplaySrc] = useState(() => resolvedSrc || FALLBACK_IMAGE)

    useEffect(() => {
        setDisplaySrc(resolvedSrc || FALLBACK_IMAGE)
    }, [resolvedSrc])

    return (
        <img
            src={displaySrc}
            alt={alt || "Prajavarta News"}
            width={width}
            height={height}
            className={className}
            style={{ objectFit, ...style }}
            loading={priority ? "eager" : "lazy"}
            decoding="async"
            fetchPriority={priority ? "high" : undefined}
            onError={() => {
                setDisplaySrc((current) =>
                    current === FALLBACK_IMAGE ? current : FALLBACK_IMAGE
                )
            }}
        />
    )
}

export default memo(CustomImage)
